import { Modal } from 'antd';
import React, { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';

import { selectOneSetting } from '../../../util/store/selectors';
import { useSelector } from '../../../util/store/store';
import { CALENDAR_VIEW, getParentEl } from '../../../util/varibles/constants';
import { PlanSetting } from '../../../util/varibles/userSetting';

import { selectPlan } from '../constants';
import Calendar from './Calendar';
import HeaderComponent from './Header';
import HorizontalCalendar from './HorizontalCalendar';
import styles from './style.module.scss';

function PreventLeave() {
    const ops = useSelector(selectPlan.ops);

    const enabled = Object.keys(ops).some(
        key => !!ops[key]?.action_type
    );

    const blocker = useBlocker(enabled);
    const modalOpenedRef = useRef(false);

    // Chặn chuyển route bên trong React app
    useEffect(() => {
        if (blocker.state !== 'blocked' || modalOpenedRef.current) {
            return;
        }

        modalOpenedRef.current = true;

        Modal.confirm({
            getContainer: getParentEl,
            title: 'Unsaved changes',
            content:
                'You have unsaved operation(s). Leaving this page will discard your change(s).',
            cancelText: 'Stay on page',
            cancelButtonProps: {
                className: 'bt-default'
            },
            okText: 'Leave without saving',
            okButtonProps: {
                className: 'bt-danger'
            },
            closable: true,
            maskClosable: true,
            keyboard: true,

            onCancel: () => {
                modalOpenedRef.current = false;
                blocker.reset();
            },

            onOk: () => {
                modalOpenedRef.current = false;
                blocker.proceed();
            },
        });
    }, [blocker]);

    // Chặn refresh, đóng tab hoặc đóng browser
    useEffect(() => {
        if (!enabled) return;

        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = '';
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener(
                'beforeunload',
                handleBeforeUnload
            );
        };
    }, [enabled]);

    return null;
}

const Plan: React.FC = () => {
    const mode = useSelector(
        selectOneSetting(PlanSetting.CALENDAR_VIEW)
    );

    return (
        <div
            id="plan"
            className={[styles['plan-view'], 'no-select'].join(' ')}
        >
            <HeaderComponent calendarView={mode} />

            <PreventLeave />

            <div
                id="content-plan"
                className={styles['view-body']}
            >
                {mode === CALENDAR_VIEW.VERTICAL
                    ? <Calendar />
                    : <HorizontalCalendar />}
            </div>
        </div>
    );
};

export default Plan;